import CreateCheckList from '../../../modules/checklists/CreateChecklist'

export default CreateCheckList;
